import { createContext, useState } from 'react'
import {
  ProviderFilterTypes,
  ProviderHeaderFilterTypes,
} from 'dataSource/ProviderSearch'

const mobileFilterModalInitial = {
  showMobileFilterModal: false,
  // eslint-disable-next-line
  setShowMobileFilterModal: (value: boolean) => undefined,
  // eslint-disable-next-line
  openMobileFilter: (value: ProviderFilterTypes | ProviderHeaderFilterTypes) =>
    undefined,
  clearFilterToExpand: () => undefined,
  filterToExpand: null,
}

type MobileFilterModalProviderProp = {
  showMobileFilterModal: boolean
  setShowMobileFilterModal: (value: boolean) => void
}

// Implicitly sets the type of the createContext
export const MobileFilterModalContext = createContext(mobileFilterModalInitial)

const MobileFilterModalProvider: React.FC<MobileFilterModalProviderProp> = ({
  children,
  showMobileFilterModal,
  setShowMobileFilterModal,
}) => {
  const [filterToExpand, setFilterToExpand] = useState<
    ProviderFilterTypes | ProviderHeaderFilterTypes
  >(null)

  const openMobileFilter = (
    filterType: ProviderFilterTypes | ProviderHeaderFilterTypes
  ) => {
    setFilterToExpand(filterType)
    setShowMobileFilterModal(true)
  }

  return (
    <MobileFilterModalContext.Provider
      value={{
        filterToExpand,
        openMobileFilter,
        clearFilterToExpand: () => setFilterToExpand(null),
        showMobileFilterModal,
        setShowMobileFilterModal,
      }}
    >
      {children}
    </MobileFilterModalContext.Provider>
  )
}

export default MobileFilterModalProvider
